import type { RescheduleScheduling } from '@src/core/buyerApiClient';

export const RescheduleStep = {
  Date: 'date',
  Time: 'time',
  Summary: 'summary',
} as const;

export type RescheduleStep = (typeof RescheduleStep)[keyof typeof RescheduleStep];

export type SchedulingsByDate = { [date: string]: RescheduleScheduling[] };
